
const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = false;



const InitPage: number = 0;
const TotalPage: number = 4;

const CVSDataTemp: ICVS = {
    init: false,
    tipoIdentificacion: '',
    identificacion: '',
    nombre1: '',
    nombre2: '',
    apellido1: '',
    apellido2: '',
    sexo: '',
    cm_p2_p1: undefined,
    cm_p2_p2: undefined,
    cm_p2_p3: undefined,
    cm_p2_p4: undefined,
    cm_p2_p5: undefined,
    cm_p3_p1: undefined,
    cm_p3_p2: undefined,
    cm_p3_p3: undefined,
    cm_p3_p4: undefined,
    cm_p3_p5: undefined,
    er_p4_p1: undefined,
    er_p4_p2: undefined,
    er_p4_p3: undefined,
    er_p4_p4: undefined,
    er_p4_p5: undefined,
    er_p4_p6: undefined,
    er_p4_p7: undefined,
    er_p4_p8: undefined,
    er_p4_p9: undefined,
    er_p4_p10: undefined,
    er_p4_p11: undefined,
    er_p5_p1: undefined,
    er_p5_p2: undefined,
    er_p5_p3: undefined,
    er_p5_p4: undefined,
    er_p5_p5: undefined,
    er_p5_p6: undefined,
    er_p5_p7: undefined,
    er_p5_p8: undefined,
    er_p5_p9: undefined,
    er_p5_p10: undefined,
    /*preguntas adicionales*/
    cm_p2_p1_1: '',
    cm_p2_p2_1: '',
    cm_p3_p2_1: '',
    cm_p3_p2_2: '',
    cm_p3_p3_1: '',
    cm_p3_p4_1: '',
    cm_p3_p4_2: '',
    cm_p3_p5_1: '',
    cm_p3_p5_2: '',
    cm_p3_p5_3: '',
    er_p5_p7_1: '',
    er_p5_p10_1: '',
    /*detalles personales */ 
    dp_p1_p1_2a: undefined,

    IDBizagi: '',
    IDCliente: '',
    saved: false
} as ICVS;

const CVSDataTempWithData: ICVS = {
    init: false,
    tipoIdentificacion: '1',
    identificacion: '570-050591-0000M',
    nombre1: 'Eddy',
    nombre2: 'Antonio',
    apellido1: 'Ortiz',
    apellido2: 'Amador',
    sexo: '1',
    cm_p2_p1: true,
    cm_p2_p2: true,
    cm_p2_p3: true,
    cm_p2_p4: true,
    cm_p2_p5: true,
    cm_p3_p1: true,
    cm_p3_p2: true,
    cm_p3_p3: true,
    cm_p3_p4: true,
    cm_p3_p5: true,
    er_p4_p1: true,
    er_p4_p2: true,
    er_p4_p3: true,
    er_p4_p4: true,
    er_p4_p5: true,
    er_p4_p6: true,
    er_p4_p7: true,
    er_p4_p8: true,
    er_p4_p9: true,
    er_p4_p10: true,
    er_p4_p11: true,
    er_p5_p1: true,
    er_p5_p2: true,
    er_p5_p3: true,
    er_p5_p4: true,
    er_p5_p5: true,
    er_p5_p6: true,
    er_p5_p7: true,
    er_p5_p8: true,
    er_p5_p9: true,
    er_p5_p10: true,
    /*preguntas adicionales*/
    cm_p2_p1_1: 'Respuesta temp cm_p2_p1_1',
    cm_p2_p2_1: 'Respuesta temp cm_p2_p2_1',
    cm_p3_p2_1: 'Respuesta temp cm_p3_p2_1',
    cm_p3_p2_2: 'Respuesta temp cm_p3_p2_2',
    cm_p3_p3_1: 'Respuesta temp cm_p3_p3_1',
    cm_p3_p4_1: 'Respuesta temp cm_p3_p4_1',
    cm_p3_p4_2: 'Respuesta temp cm_p3_p4_2',
    cm_p3_p5_1: 'Respuesta temp cm_p3_p5_1',
    cm_p3_p5_2: 'Respuesta temp cm_p3_p5_2',
    cm_p3_p5_3: 'Respuesta temp cm_p3_p5_3',
    er_p5_p7_1: 'Respuesta temp er_p5_p7_1',
    er_p5_p10_1: 'Respuesta temp er_p5_p10_1',
    IDBizagi: '118342',
    IDCliente: '97736',
    saved: false
} as ICVS;

const setObj = () => (setData && isDevelopment) ? ({ ...CVSDataTempWithData }) : ({ ...CVSDataTemp });

const CVSDefault: ICVS = setObj();

export { CVSDefault, InitPage, TotalPage };